import { DevSettings } from '../support/DevSettings';
import { State } from '@meraki-internal/state';
import { OperatorFlagsState } from '../profile/OperatorFlagsState';
import { AutoPylotPrincipal } from '../auth/AutoPylotPrincipal';
import { App, AppState } from '@capacitor/app';
import { Logger } from '../support/debug/Logger';
import { TrackingService } from '../support/tracking/TrackingService';

export class ProState extends State<Record<string, never>> {
    static inject = () => [
        DevSettings,
        OperatorFlagsState,
        AutoPylotPrincipal,
        Logger,
        TrackingService
    ];
    constructor(
        private devSettings: DevSettings,
        private flagsState: OperatorFlagsState,
        private principal: AutoPylotPrincipal,
        private logger: Logger,
        private tracker: TrackingService
    ){
        super({});
    }

    init = async () => {
        await this.flagsState.load();

        App.addListener('appStateChange', async ({ isActive }: AppState) => {

            if (isActive) { // foregrounding
                this.flagsState.load()
                    .then(() => {
                        // flags might have changed so emit
                        this.setState({ });
                    })
                    .catch(err => {
                        this.logger.error(`failed to refresh flags on foregrounding. ${err.toString()}`);
                    });
            }
        });

    };

    /**
     * Does the user have access to the dark feature? (this will be driven by API targeting)
     */
    canSeePreMissionWeather = () => {
        return this.hasPro() || this.flagsState.hasFlag('preMissionWeather') || this.devSettings.preMissionWeather;
    };

    isShowingPaywall = false;

    showPaywall = (source: string) => {
        this.tracker.track('Paywall Opened', () => ({
            from: source,
            Experiments: this.flagsState.getExperiments()
        }));

        this.isShowingPaywall = true;
        this.setState({ });
    };

    closePaywall = () => {
        this.isShowingPaywall = false;
        this.setState({ });
    };

    hasPro = () => {
        return this.flagsState.hasFlag('e_pro');
    };

    upgrade = async () => {
        this.tracker.track('Paywall Converted to Pay', () => ({
            Experiments: this.flagsState.getExperiments()
        }));

        await this.flagsState.addFlagToUser({
            userId: this.principal.userId,
            flag: 'e_pro'
        });
        this.setState({ });
    };

    downgrade = async () => {
        await this.flagsState.removeFlagFromUser({
            userId: this.principal.userId,
            flag: 'e_pro'
        });
        this.setState({ });
    };
}
